import KomgaDictionaryService from '@/services/komga-dictionary.service'
import { AxiosInstance } from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$komgaDictionary = new KomgaDictionaryService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $komgaDictionary: KomgaDictionaryService;
  }
}

